import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './questionnaires.magic.css.js';
import script from './questionnaires.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('magic-ui-loader'):_c('div',{staticClass:"questionnaire",attrs:{"part":"questionnaire","data-v-test-id":"questionnaire"}},[_c('magic-ui-text',{staticClass:"intro",attrs:{"tag":"p","part":"intro","data-v-test-id":"questionnaire-intro","content":_vm.questionnairesList && _vm.questionnairesList.length > 0 ? _vm.$t('questionnaire.intro') : _vm.$t('questionnaire.empty')}}),_vm._v(" "),_c('ul',{staticClass:"list",attrs:{"part":"list","data-v-test-id":"questionnaire-list"}},[_vm._l((_vm.questionnairesList),function(questionnaire,index){return _c('li',{key:index,staticClass:"item",attrs:{"part":"item"}},[_c('div',{staticClass:"item-content"},[_c('magic-ui-text',{staticClass:"item-title",attrs:{"tag":"p","part":"item-title","content":questionnaire.questionnaireTemplateName}}),_vm._v(" "),_c('div',{staticClass:"status"},[_c('magic-ui-icon',{staticClass:"icon",class:_vm.getStatusClasses(questionnaire.status),attrs:{"name":_vm.getStatusIcons(questionnaire.status)}}),_vm._v(" "),_c('span',{class:_vm.getStatusClasses(questionnaire.status),domProps:{"innerHTML":_vm._s(_vm.getStatusTranslations(questionnaire.status))}})],1)],1),_vm._v(" "),_c('magic-ui-button',{attrs:{"variant":"primary","small":"","no-margin":"","disabled":_vm.isButtonEnabled(questionnaire.status)},domProps:{"innerHTML":_vm._s(_vm.$t('questionnaire.button'))},on:{"click":function($event){return _vm.openQuestionnaire(questionnaire)}}})],1)}),_vm._v(" "),_c('magic-questionnaire')],2)],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-45ac89b5_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-45ac89b5";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
